import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { MenuBook } from './models';

const menuBookService = {
  getAll(params: {
    name: string;
    except_menu_book_ids: string;
    except_course_ids: string;
  }): Promise<CommonResponse<MenuBook[]>> {
    const url = '/menubooks';
    return axiosClient.get(url, { params });
  },
};

export default menuBookService;
